var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableHealthInsuranceTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.447,
    height: 21.98,
    viewBox: "0 0 19.447 21.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3912",
    "data-name": "Path 3912",
    d: "M220.386,199.645a.43.43,0,0,0-.43-.43h-3.78a.43.43,0,0,0,0,.859h3.78A.43.43,0,0,0,220.386,199.645Zm0,0",
    transform: "translate(-206.506 -190.663)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    d: "M66.49,99.125h-.8a.89.89,0,0,0-.89.888v.414H64.39a.891.891,0,0,0-.89.89v.8a.891.891,0,0,0,.89.89H64.8v.414a.891.891,0,0,0,.89.89h.8a.891.891,0,0,0,.89-.89V103h.414a.891.891,0,0,0,.89-.89v-.8a.891.891,0,0,0-.89-.89h-.414v-.414A.89.89,0,0,0,66.49,99.125Zm1.3,2.161a.032.032,0,0,1,.031.03v.8a.032.032,0,0,1-.031.03h-.844a.43.43,0,0,0-.43.43v.843a.032.032,0,0,1-.031.03h-.8a.032.032,0,0,1-.031-.03v-.843a.43.43,0,0,0-.43-.43H64.39a.032.032,0,0,1-.031-.03v-.8a.032.032,0,0,1,.031-.03h.844a.43.43,0,0,0,.43-.43v-.843a.031.031,0,0,1,.031-.029h.8a.031.031,0,0,1,.031.029v.843a.43.43,0,0,0,.43.43Zm0,0",
    transform: "translate(-60.795 -94.87)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M220.573,139.918a.43.43,0,0,0-.43-.43h-3.967a.43.43,0,0,0,0,.859h3.967A.43.43,0,0,0,220.573,139.918Zm0,0",
    transform: "translate(-206.506 -133.5)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M70.652,259.77h9.838a.43.43,0,0,0,0-.859H70.652a.43.43,0,1,0,0,.859Zm0,0",
    transform: "translate(-67.23 -247.796)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M19.582,13.575a10.977,10.977,0,0,1-2.466-.621V9.218a.43.43,0,1,0-.859,0V12.48A2.123,2.123,0,0,1,16,12.253a.43.43,0,0,0-.624,0,6.484,6.484,0,0,1-3.582,1.322.427.427,0,0,0-.219.1H3.923a.43.43,0,1,0,0,.859H11.43v1.7H3.635a.43.43,0,1,0,0,.859h7.829a5.4,5.4,0,0,0,1.493,2.994H2.585A1.225,1.225,0,0,1,1.36,18.871V3.031A1.225,1.225,0,0,1,2.585,1.809H4.636v.159a.79.79,0,0,0,.79.789h6.764a.79.79,0,0,0,.79-.789V1.809h2.051a1.225,1.225,0,0,1,1.225,1.223V5.79a.43.43,0,1,0,.859,0V3.031A2.086,2.086,0,0,0,15.032.949H12.981V.789A.79.79,0,0,0,12.191,0H5.426a.79.79,0,0,0-.79.789v.16H2.585A2.086,2.086,0,0,0,.5,3.031v15.84a2.086,2.086,0,0,0,2.085,2.082h11.3c.774.664,1.251,1.026,1.806,1.026h0c.624,0,1.149-.454,2.1-1.278a5.635,5.635,0,0,0,2.157-3.95c0-.008,0-.017,0-.025V14a.43.43,0,0,0-.365-.425ZM5.5.859h6.626V1.9H5.5ZM19.088,16.713a4.819,4.819,0,0,1-1.861,3.338c-.744.644-1.236,1.069-1.539,1.069h0c-.3,0-.766-.4-1.536-1.069a4.824,4.824,0,0,1-1.862-3.339V14.366a7.643,7.643,0,0,0,3.4-1.238,4.2,4.2,0,0,0,.784.48.422.422,0,0,0,.061.029,10.229,10.229,0,0,0,2.554.73Zm0,0",
    transform: "translate(-0.501 0)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3917",
    "data-name": "Path 3917",
    d: "M309.639,357.75l-.756-.709a.43.43,0,0,0-.588.627l1.074,1.007a.429.429,0,0,0,.294.116h.017a.43.43,0,0,0,.3-.14l2.178-2.395a.43.43,0,0,0-.636-.578Zm0,0",
    transform: "translate(-294.952 -340.275)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3918",
    "data-name": "Path 3918",
    d: "M367.961,164.6a.43.43,0,0,0-.43.43v.007a.43.43,0,0,0,.859,0v-.007A.43.43,0,0,0,367.961,164.6Zm0,0",
    transform: "translate(-351.775 -157.536)",
    fill: "#199b8b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableHealthInsuranceTypeIcon);
export default __webpack_public_path__ + "static/media/table-health-insurance-type-icon.8261b03604052c948e9da3bb81c9cc59.svg";
export { ForwardRef as ReactComponent };